// prettier-ignore
const env = {
  basePath: process.env.REACT_APP_ENV === 'production' ? 'https://storeyview.com'
          : process.env.REACT_APP_ENV === 'staging' ? ''
          : 'http://localhost:8080',
  socketPath: process.env.REACT_APP_ENV === 'production' ? 'wss://storeyview.com'
  : process.env.REACT_APP_ENV === 'staging' ? ''
  : 'ws://localhost:8080'
}

export default env;
